// services/vendorNotesService.js
import axiosInstance from './AxiosInstance';

const fetchVendorNotes = async (vendorId, page = 1, pageSize = 10, sortBy = "", order = "asc") => {
  const queryObj = {
    page,
    pageSize,
  };

  if (sortBy) {
    queryObj.sortBy = sortBy;
    queryObj.order = order;
  }

  try {
    const response = await axiosInstance.get(`/vendors/${vendorId}/notes`, {
      params: queryObj,
    });
    
    if (response.data?.data) {
      const vendorNotes = response.data.data.map(note => ({
        ...note,
        id: note.note_id,
      }));
      return {
        notes: vendorNotes,
        totalRecords: response.data.totalRecords,
      };
    }
    
    throw new Error('Invalid data structure received from API');
  } catch (error) {
    console.error('Failed to fetch vendor notes:', error);
    throw error;
  }
};

const createVendorNote = async (vendorId, noteData) => {
  try {
    const response = await axiosInstance.post(`/vendors/${vendorId}/notes`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error creating vendor note:', error);
    throw error;
  }
};

const updateVendorNote = async (vendorId, noteId, noteData) => {
  try {
    
    const response = await axiosInstance.put(`/vendors/${vendorId}/notes/${noteId}`, noteData);
    return response.data;
  } catch (error) {
    console.error('Error updating vendor note:', error);
    throw error;
  }
};

const deleteVendorNote = async (vendorId, noteId) => {
  try {
    const response = await axiosInstance.delete(`/vendors/${vendorId}/notes/${noteId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting vendor note:', error);
    throw error;
  }
};

export { 
  fetchVendorNotes, 
  createVendorNote, 
  updateVendorNote, 
  deleteVendorNote 
};